<template>
  <BaseLayout :menuLinks="sideMenuLinks">
    <template v-slot>
      <div class="flex flex-column align-items-center justify-content-center w-full" style="min-height: 60vh">
        <div class="text-center">
          <i class="pi pi-exclamation-circle text-yellow-500" style="font-size: 5rem"></i>
          <h1 class="text-5xl font-bold mt-4 mb-2">404</h1>
          <h2 class="text-3xl font-medium mb-5">Page Not Found</h2>
          <p class="text-xl text-700 mb-5">
            The page you are looking for doesn't exist or has been moved.
          </p>
          <div class="flex justify-content-center">
            <Button label="Go Back" icon="pi pi-arrow-left" class="mr-2" @click="$router.go(-1)" />
            <Button label="Go Home" icon="pi pi-home" severity="primary" @click="navigateToHome" />
          </div>
        </div>
      </div>
    </template>
  </BaseLayout>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';
import BaseLayout from '@/components/BaseLayout.vue';
import { menuLinks } from '@/shared/sharedLinks.js';

const router = useRouter();
const sideMenuLinks = ref(menuLinks);

const navigateToHome = () => {
  router.push('/'); // Or use the path to your actual home page
};
</script>